import { ReactNode, useState } from "react";
import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";
import DfyStickyCostBreakdown from "./DfyStickyCostBreakdown";

export interface DfyNextConfirmation {
  title: string;
  description: string;
}

export default function DfyStepNavigation({
  onBack,
  onNext,
  nextLabel = "Next",
  nextDisabled = false,
  nextConfirmation = null,
  showCostSummary = true,
}: {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: ReactNode;
  nextDisabled?: boolean;
  nextConfirmation?: DfyNextConfirmation | null;
  showCostSummary?: boolean;
}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleNext = () => {
    if (nextConfirmation) {
      setConfirmOpen(true);
      return;
    }
    onNext?.();
  };

  return (
    <>
      {showCostSummary && (
        <div className="@5xl:hidden">
          <DfyStickyCostBreakdown />
        </div>
      )}
      <div className="mt-6 flex justify-between">
        {onBack && (
          <Button variant="outline" onClick={onBack}>
            Back
          </Button>
        )}
        {onNext && (
          <Button
            className="ml-auto"
            disabled={nextDisabled}
            onClick={handleNext}
          >
            {nextLabel}
          </Button>
        )}
      </div>

      {nextConfirmation && (
        <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
          <DialogContent className="max-w-md">
            <DialogHeader className="w-full">
              <DialogTitle>{nextConfirmation.title}</DialogTitle>
              <DialogDescription>
                {nextConfirmation.description}
              </DialogDescription>
            </DialogHeader>
            <DialogFooter className="mt-0">
              <Button
                onClick={() => {
                  setConfirmOpen(false);
                  onNext?.();
                }}
              >
                Continue
              </Button>
              <DialogClose asChild>
                <Button type="button" variant="outline">
                  Cancel
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
